module.exports = __webpack_public_path__ + "img/image6.92a3e0e5.png";